<div class="category-header">
  <button
    tuiIconButton
    class="button_back"
    type="button"
    iconStart="@tui.chevron-left"
    [appearance]="'grey-button'"
    [size]="isDesktop ? 'm' : 's'"
    (click)="back.emit()"
  ></button>

  <span class="title" [ngClass]="isDesktop ? 'text_heading-5' : 'text_size-m-2'">{{ title }}</span>
</div>
